import { WhitelistItem } from 'multirpc-sdk';
import { AnyAction, ThunkDispatch } from '@reduxjs/toolkit';

import { RootState } from 'store';

import { fetchProjectWhitelist } from '../fetchProjectWhitelist';

export interface GetCurrentWhitelistChainsParams {
  userEndpointToken: string;
  group?: string;
  dispatch: ThunkDispatch<RootState, unknown, AnyAction>;
}

export interface WhitelistChainsResult {
  chains: string[];
  items: WhitelistItem[];
}

export async function getCurrentWhitelistChains(
  params: GetCurrentWhitelistChainsParams,
): Promise<WhitelistChainsResult> {
  const { dispatch, group, userEndpointToken } = params;

  try {
    const whitelistResult = await dispatch(
      fetchProjectWhitelist.initiate({ userEndpointToken, group }),
    );

    if (whitelistResult.data?.lists) {
      return {
        chains: whitelistResult.data.lists.map(
          (item: WhitelistItem) => item.blockchain,
        ),
        items: whitelistResult.data.lists,
      };
    }

    return { chains: [], items: [] };
  } catch (_error) {
    return { chains: [], items: [] };
  }
}
